import React from 'react';
import { Link } from 'react-router-dom';

interface ReportHeaderProps {
  isLoggedIn: boolean;
}

export default function ReportHeader({ isLoggedIn }: ReportHeaderProps) {
  return (
    <header className="sticky top-0 z-50 h-16 bg-[#f6f5f0]/80 backdrop-blur-xl border-b border-[rgba(29,25,38,0.08)]">
      <div className="max-w-[1000px] mx-auto px-6 h-full flex items-center justify-between">
        <Link to="/">
          <img
            src="/logos/logo-dark.png"
            alt="Tasky"
            className="h-7 w-auto"
          />
        </Link>
        <div>
          {isLoggedIn ? (
            <Link
              to="/dashboard"
              className="text-[14px] text-[#1d1926]/60 hover:text-[#1d1926] transition-colors"
            >
              ダッシュボード
            </Link>
          ) : (
            <Link
              to="/signup"
              className="inline-flex items-center h-9 px-5 rounded-full bg-[#1d1926] text-[#f6f5f0] text-[14px] font-medium hover:opacity-90 transition-opacity"
            >
              ログイン / 登録
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
